import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import FileDownload from 'js-file-download';
import AuthContext from '../contexts/AuthContext';

import { rest } from '../utils/rest';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

export const createReport = props => {
  const { credentials, params, onCompleted } = props;
  // setDownloading(type);

  const options = {
    credentials,
    params,
    path: `reports/asset-fees`,
    headers: {
      Accept: 'application/pdf',
    }
  };

  const timestamp = new Date().getTime();
  // let fullFilename = `${filename || path}-${timestamp}.pdf`;


  rest(options).then(response => {
    // response.blob().then(blob => FileDownload(blob, fullFilename));
    // setDownloading(false);
    if (onCompleted) { onCompleted(); }
  });
};
